/** Was der Kunde bei der Anmeldung auf der Website angehakt hat (T-0201). */
export interface Einwilligungen {
  agb: boolean;
  datenschutz: boolean;
  newsletter: boolean;
  zeitpunkt: string | null;
}

const jaNein = (wert: boolean) => (wert ? 'ja' : 'nein');

export function einwilligungenText(e: Einwilligungen): string {
  const teile = [
    `AGB: ${jaNein(e.agb)}`,
    `Datenschutz: ${jaNein(e.datenschutz)}`,
    `Newsletter: ${jaNein(e.newsletter)}`,
  ];
  const zeit = e.zeitpunkt ? new Date(e.zeitpunkt) : null;
  if (zeit && !Number.isNaN(zeit.getTime())) {
    teile.push(`am ${zeit.toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' })}`);
  }
  return teile.join(' · ');
}
